// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__kTlTq","hosts":"footer_hosts__M4tTy","partnerLogo":"footer_partnerLogo__FaMe3","container":"footer_container__wJnvA","section":"footer_section__0HCK0"};